export const refusalInstructions = {
  1: "1 - Não tem devolução",
  3: "3 - Devolver e ter valor restituído",
  4: "4 - Devolver e ter mercadoria reposta"
};
